import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useUpdateSections = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const updateSections = (payload, onSuccess) => {
    setLoading(true);
    axiosClient
      .post(`InventoryAgent/AccessibleSection`, {
        guid: payload.guid,
        sectionsGuid: payload.sectionsGuid,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`ویرایش با موفقیت انجام شد`, { variant: 'success' });
          onSuccess?.();
          setLoading(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
          setLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
        setLoading(false);
      })
      .finally(() => setLoading(false));
  };
  return { updateSections, loading };
};

export default useUpdateSections;
